export const renderErrorFallback = (props: {
  eventId: string | undefined;
  resetError?: () => void;
}) => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4">
      <div className="text-2xl text-foreground">
        Something went wrong. Please refresh and try again.
      </div>

      {props.resetError ? (
        <button
          onClick={props.resetError}
          className="rounded-sm bg-gray-800 px-4 py-2 text-white transition-colors hover:bg-gray-700"
        >
          Refresh
        </button>
      ) : null}

      {props.eventId ? (
        <div className="text-sm text-gray-400">Error ID: {props.eventId}</div>
      ) : null}
    </div>
  );
};
